import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from 'src/app/login/login.service';
import { SessionService } from 'src/app/shared/services/session.service';


/*
  NOTE Impede que quando logado possa retornar para rotas de login e cadastro
  de contas.
*/

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  private permissionAcess: boolean;
  private role;

  constructor(private loginService: LoginService,
    private sessionService: SessionService) {
      this.role = this.sessionService.role;
      this.loginService.isLoggedIn().subscribe(response => {
        this.permissionAcess = response;
      }
      );
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    console.warn('Auth Login');
    return this.checkAccess();
  }

  checkAccess() {
    if (this.permissionAcess) {
      return false;
    }
    return true;
  }
}
